import LoadingImage from "components/LoadingImage";
import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "store/hooks";
import { authenticate } from "store/slices/auth";
import { APIAuthenticateUserWithProviderCode, APIValidateToken } from "utils/api";
import { MENTOR_HOME_JOIN_FORM } from "layouts/components/Header";
import { RECRUITER_HOME_JOIN_FORM } from "layouts/components/Header";

export function navigateWithJourney(navigate: any, j: string, user: any, searchParams: any) {
  if (searchParams.get("forward")) {
    return;
  }

  if (j === "recruiter"){
    if (user && user._organizations && user._organizations.length > 0) {
      navigate("/recruiter/qualification-catalog");
    } else {
      window.location.href = RECRUITER_HOME_JOIN_FORM;
    }
  } else if (j === "mentor"){
    if (user && user._mentor && user._mentor.is_active) {
      navigate("/profile/mentor-page");
    } else {
      window.location.href = MENTOR_HOME_JOIN_FORM;
    }
  } else {
    navigate("/");
  }
}

export default function LoginPage() {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [searchParams] = useSearchParams();
  const journey = useAppSelector((state) => state.auth.journey);


  useEffect(() => {
    const code = searchParams.get("code");
    const provider = searchParams.get("provider");
    const j = journey || localStorage.getItem("j");
    console.log("j", j);
    if (code) {
      APIAuthenticateUserWithProviderCode(provider, code)
        .then(() => {
          dispatch(authenticate(true, null));
          APIValidateToken()
            .then((res) => res.data)
            .then((user) => {
              navigateWithJourney(navigate, j, user, searchParams);
            })
            .catch(() => {
              navigate("/error");
            });
        })
        .catch(() => {
          navigate("/error");
        });
        // TODO: navigate to page visited before login else home page
    } else {
      navigate("/error");
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div style={{
      display: "flex",
      width: "100vw",
      height: "100vh", 
    }}>
      <LoadingImage></LoadingImage>
    </div>
  );
}
